import React from "react";
import { withTranslation } from "react-i18next";
import { LocalStorageService, ContractService, CompanyService, ContractorService, CategoryService, QuestionnaireService } from "../../../services";
import QuestionnairesAdministrationView from "../../views/questionnaires-administration/questionnaires-administration.view";
import { NIL as NIL_UUID } from 'uuid';


class QuestionnairesAdministrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      token: "",
      user: {},
      questionnairesByUser: [],
      companysForUser: [],
      showLoadingRequesting: false,
      showErrorRequesting: false,
      showCompletedRequesting: false,
      companySelectQuestionnaires: '',
      filterStatusQuestionnaires: NIL_UUID,
      personTypes: [],
      standardContract: false,
      userCompanies: [{ companyName: this.props.t("questionnairesAssignCategories.no.assign"), id: NIL_UUID }],
      categories: [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }],
      subCategories: [{ items: [], subcategory: {} }],
      typeDocuments: [],
    };
  }

  token = {};
  user = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  companyService = new CompanyService(this.url);
  contractorService = new ContractorService(this.url)
  categoryService = new CategoryService(this.url);
  questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);

  async componentDidMount() {
    let { state } = this.props.location
    let standardContract
    if (state && state.standardContract) standardContract = true
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let user = this.localStorageService.getLocalStorageItem("user");
    this.user = user

    try {
      this.setState({
        user,
        token: this.token,
        standardContract
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }

    if (user) {
      let userId = user.userMetaData.userA3Cloud.clientId;
      let questionnairesByUser =
        await this.contractService.getQuestionnairesByUserId(
          this.token,
          userId
        );
      let companysClient = await this.companyService.getCompanys(this.token)
      let allCompanys = []

      for (let i = 0; i < companysClient.data.data.length; i++) {
        if (companysClient.data.data[i].company.companyName !== null && companysClient.data.data[i].company.companyName !== '' && companysClient.data.data[i].company.id !== null && companysClient.data.data[i].company.id !== '' && companysClient.data.data[i].company.status === true) {
          let info = {}
          info = {
            id: companysClient.data.data[i].company.id,
            companyName: companysClient.data.data[i].company.companyName
          }
          allCompanys.push(info)
        }
      }
      allCompanys = allCompanys.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));

      let noAssign = {
        companyName: this.props.t("questionnairesAssignCategories.no.assign"),
        id: NIL_UUID
      }

      allCompanys.unshift(noAssign)

      this.setState({
        loading: false,
        questionnairesByUser: questionnairesByUser.data.data,
        companysForUser: allCompanys
      });

    }
  }

  toggleErrorRequesting = (value) => {
    this.setState({
      showErrorRequesting: value
    }, () => {
      setTimeout(() => {
        this.setState({ showErrorRequesting: false })
      }, 2000)
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, questionnaires) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: '',
            questionnairesByUser: questionnaires || [],
          });
          // funcion()
        }, 4000);
      }
    );
  };

  toggleCompletedQuestionsRequesting = (value) => {
    this.setState({
      showCompletedRequesting: value,
    });
  }

  changeRedirect = (value) => {
    this.setState({
      standardContract: value
    })
  }

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  setCompanySelectQuestionnaires = (value) => {
    this.setState({
      companySelectQuestionnaires: value
    })
  }

  setFilterStatusQuestionnaires = (value) => {
    this.setState({
      filterStatusQuestionnaires: value
    })
  }
  //get persontypes
  getContractPersonTypes = async () => {
    try {
      let contractorPersonType = await this.contractorService.getPersonTypeByKey('documentType', this.token)
      if (contractorPersonType && contractorPersonType.data && Number(contractorPersonType.statusCode) === 200) {
        let personTypes = contractorPersonType.data.filter((type) => type.id === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_ID) || type.id === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID))
        this.setState({
          personTypes
        })
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true)
        setTimeout(() => {
          this.toggleErrorRequesting(true)
          this.props.history.push("/")
        }, 4000)
      }
    } catch (error) {
      console.log(error)
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true)
      setTimeout(() => {
        this.toggleErrorRequesting(true)
        this.props.history.push("/")
      }, 4000)
    }
  }

  getTypeDocuments = async () => {
    try {
      let typeDocumentsBD = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (typeDocumentsBD && typeDocumentsBD.data && Number(typeDocumentsBD.statusCode) === 200) {
        let typeDocuments = typeDocumentsBD.data;
        typeDocuments.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        this.setState({
          typeDocuments
        })
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.typedocuments") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.typedocuments") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getUserCompanies = async () => {
    this.toggleLoadingRequesting(true)
    try {
      let companiesBD = await this.companyService.getUsersCompanies(this.token)
      if (companiesBD && companiesBD.data && Number(companiesBD.statusCode) === 200) {
        let companies = companiesBD.data.map(company => ({
          id: company.company.id,
          companyName: company.company.companyName,
        }))
        companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
        let noAssign = {
          companyName: this.props.t("questionnairesAssignCategories.no.assign"),
          id: NIL_UUID
        }
        companies.unshift(noAssign)
        this.setState({
          companies,
          categories: [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }],
          subCategories: [{ items: [], subcategory: {} }]
        })

        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.companies") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.companies") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getUserCategories = async (companyId, setCategoryId, setSelect) => {
    if (companyId === NIL_UUID) {
      this.setState({
        categories: [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }],
        subCategories: [{ items: [], subcategory: {} }]
      })

      setCategoryId(0)
      setSelect([""])
      return
    }
    this.toggleLoadingRequesting(true)
    try {
      let categoriesBD = await this.categoryService.getCategories(this.token, companyId);
      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let categories = categoriesBD.data
        categories = categories.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        let noAssign = { id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }
        categories.unshift(noAssign)
        this.setState({
          categories,
          subCategories: [{ items: [], subcategory: {} }]
        })


        setCategoryId(0)
        setSelect([""])
        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.categories") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.categories") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getUserSubcategires = async (companyId, categoryId, setSelect) => {
    setSelect([""])
    if (companyId === NIL_UUID || categoryId === 0) {
      this.setState({
        subCategories: [{ items: [], subcategory: {} }]
      })
      return
    }
    this.toggleLoadingRequesting(true)

    try {
      let subCategoriesBD = await this.categoryService.getSubcategories(this.token, companyId, categoryId);
      if (subCategoriesBD && subCategoriesBD.data && Number(subCategoriesBD.statusCode) === 200) {
        let subCategories = subCategoriesBD.data
        subCategories = subCategories.sort((a, b) => a.subcategory.name.toLowerCase().localeCompare(b.subcategory.name.toLowerCase()));

        this.setState({
          subCategories
        })


        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t("signatureRequestProfileAction.error.subcategories") })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t("signatureRequestProfileAction.error.subcategories") })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  handleAssignCategories = async (data, hideShowDetails) => {
    this.toggleLoadingRequesting(true)
    try {
      let { solicitudeId, companyId, categoryId, subCategoryId, typeDocument, pathBreadcrumb } = data
      let classifier = await this.questionnaireService.createOrUpdateClassifier(solicitudeId, companyId, categoryId, subCategoryId, typeDocument, pathBreadcrumb, this.token)
      if (classifier && classifier.data && Number(classifier.statusCode) === 200) {
        let userId = this.user.userMetaData.userA3Cloud.clientId;
        let questionnaires = await this.contractService.getQuestionnairesByUserId(this.token, userId);
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(true, "", questionnaires.data.data);
        setTimeout(() => {
          hideShowDetails()
        }, 4000)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true)
    }
  }

  setDigitalVaultCategory = async (selectedQuestionnaire, setCompanyId, setTypeDocument, setCategoryId, setSelect, setExpand) => {
    this.toggleLoadingRequesting(true)
    let categories = [{ id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }]
    let subCategories = [{ items: [], subcategory: {} }]
    let pathBreadcrumbSelected = (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.pathBreadcrumb) ? selectedQuestionnaire.classifier.pathBreadcrumb : ''
    let index = ''

    try {
      //Get companies
      let companiesBD = await this.companyService.getUsersCompanies(this.token)
      if (!companiesBD || !companiesBD.data || Number(companiesBD.statusCode) !== 200) throw new Error(this.props.t("signatureRequestProfileAction.error.companies"))
      let companies = companiesBD.data.map(company => ({
        id: company.company.id,
        companyName: company.company.companyName,
      }))
      companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()));
      let noAssign = {
        companyName: this.props.t("questionnairesAssignCategories.no.assign"),
        id: NIL_UUID
      }
      companies.unshift(noAssign)

      //GET type documents
      let typeDocumentsBD = await this.categoryService.getTypeDocuments(this.token, 'Documento');
      if (!typeDocumentsBD || !typeDocumentsBD.data || Number(typeDocumentsBD.statusCode) !== 200) throw new Error(this.props.t("signatureRequestProfileAction.error.typedocuments"))
      let typeDocuments = typeDocumentsBD.data;
      typeDocuments.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      let typeDocumentSelected
      if (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.typeDocumentId) {
        typeDocumentSelected = typeDocuments.find(doc => doc.id === selectedQuestionnaire.classifier.typeDocumentId)
      }

      if (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.categoryId && selectedQuestionnaire.classifier.subCategoryId) {
        //GET categories
        let categoriesBD = await this.categoryService.getCategories(this.token, selectedQuestionnaire.classifier.companyId);
        if (!categoriesBD || !categoriesBD.data || Number(categoriesBD.statusCode) !== 200) throw new Error(this.props.t("signatureRequestProfileAction.error.categories"))
        categories = categoriesBD.data
        categories = categories.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

        let noAssign = { id: 0, name: this.props.t("questionnairesAssignCategories.no.assign") }
        categories.unshift(noAssign)

        //GET subcategories
        let subCategoriesBD = await this.categoryService.getSubcategories(this.token, selectedQuestionnaire.classifier.companyId, selectedQuestionnaire.classifier.categoryId);
        if (!subCategoriesBD || !subCategoriesBD.data || Number(subCategoriesBD.statusCode) !== 200) throw new Error('Ocurrió un error al consultar las subcategorías')
        subCategories = subCategoriesBD.data
        subCategories = subCategories.sort((a, b) => a.subcategory.name.toLowerCase().localeCompare(b.subcategory.name.toLowerCase()));

        if (selectedQuestionnaire.classifier.pathBreadcrumb) {
          let pathBreadcrumbSelected = selectedQuestionnaire.classifier.pathBreadcrumb
          let idsExpand = []

          let pathSplit = pathBreadcrumbSelected.split("/")
          if (pathSplit && pathSplit.length === 1) {
            index = subCategories.findIndex(sub => sub.subcategory.id === Number(pathBreadcrumbSelected))
          }

          if (pathSplit && pathSplit.length === 2) {
            let subSplit = pathBreadcrumbSelected.split('/')
            let catId = (subSplit) ? subSplit[0] : 0
            let subId = (subSplit) ? subSplit[1] : 0
            let catIndex = subCategories.findIndex(cat => cat.subcategory.id === Number(catId))
            let catFind = subCategories[catIndex]
            let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
            index = `${catIndex}_${subIndex}`
          }

          if (pathSplit && pathSplit.length === 3) {
            let subSplit = pathBreadcrumbSelected.split('/')
            let catId = (subSplit) ? subSplit[0] : 0
            let subId = (subSplit) ? subSplit[1] : 0
            let subSubId = (subSplit) ? subSplit[2] : 0
            let catIndex = subCategories.findIndex(cat => cat.subcategory.id === Number(catId))
            let catFind = subCategories[catIndex]
            let subIndex = catFind.items.findIndex(sub => sub.subcategory.id === Number(subId))
            let subCat = catFind.items[subIndex]
            let subSubIndex = subCat.items.findIndex(sub => sub.subcategory.id === Number(subSubId))

            index = `${catIndex}_${subIndex}_${subSubIndex}`
          }

          pathSplit.map(indexPath => idsExpand.push(Number(indexPath)))
          setExpand(prev => ({
            ids: [...new Set([...prev.ids, ...idsExpand])],
            idField: "subcategory.id"
          }))
        }
      }

      let companyId = (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.companyId) ? selectedQuestionnaire.classifier.companyId : NIL_UUID
      let typeDocument = typeDocumentSelected || {}
      let categoryId = (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.categoryId) ? selectedQuestionnaire.classifier.categoryId : 0
      let subcategoryId = (selectedQuestionnaire && selectedQuestionnaire.classifier && selectedQuestionnaire.classifier.subCategoryId) ? selectedQuestionnaire.classifier.subCategoryId : 0



      setCompanyId(companyId)
      setTypeDocument(typeDocument)
      setCategoryId(categoryId)
      setSelect([`${index}`])

      this.setState({
        companyIdSelected: companyId,
        typeDocumentSelected: typeDocument,
        categoryIdSelected: categoryId,
        subsubCategoryIdSelected: subcategoryId,
        userCompanies: companies,
        categories,
        subCategories,
        typeDocuments,
        pathBreadcrumbSelected
      })

      this.toggleLoadingRequesting(false)

    } catch (error) {
      this.toggleLoadingRequesting(false)
      return false
    }
  }

  onExpandTree = (e) => {
    let subs = this.state.subCategories.map((sub) => {
      sub.expanded = (e.item.subcategory.id === sub.subcategory.id) ? !sub.expanded : false
      return sub
    })

    this.setState({
      subCategories: subs
    })
  }

  render() {
    return <QuestionnairesAdministrationView
      {...this.state}
      changeRedirect={this.changeRedirect}
      forceRefresh={this.forceRefresh}
      toggleErrorRequesting={this.toggleErrorRequesting}
      toggleLoadingRequesting={this.toggleLoadingRequesting}
      toggleCompletedRequesting={this.toggleCompletedRequesting}
      toggleCompletedQuestionsRequesting={this.toggleCompletedQuestionsRequesting}
      setCompanySelectQuestionnaires={this.setCompanySelectQuestionnaires}
      setFilterStatusQuestionnaires={this.setFilterStatusQuestionnaires}
      getContractPersonTypes={this.getContractPersonTypes}

      getUserCompanies={this.getUserCompanies}
      getUserCategories={this.getUserCategories}
      getUserSubcategires={this.getUserSubcategires}
      getTypeDocuments={this.getTypeDocuments}
      handleAssignCategories={this.handleAssignCategories}
      setDigitalVaultCategory={this.setDigitalVaultCategory}
      onExpandTree={this.onExpandTree}
      changeRoute={this.props.changeRoute}
    />;
  }
}

export default withTranslation()(QuestionnairesAdministrationAction);

